// The root-scoped service worker: frontend.md, "Service worker".
if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/service-worker").catch(() => {});
	});
}
